import { Form, Input, Button, Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function Login() {
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const res = await api.post("/auth/login", values);

      // Store token & user
      localStorage.setItem("token", res.data.token);
      localStorage.setItem(
        "user",
        JSON.stringify(res.data.user)
      );

      const role = res.data.user.role;

      if (role === "admin") {
        navigate("/admin/dashboard");
      } 
      else if (["manager","employee"].includes(role)) {
        navigate("/my-orders");
      } 
      else {
        navigate("/home");
      }

    } catch (err) {
      message.error(
        err.response?.data?.message || "Something went wrong"
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: 100
      }}
    >
      <Card title="Login" style={{ width: 400 }}>
        <Form layout="vertical" onFinish={onFinish}>
          
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 16
            }}
          >
            <Button
              type="link"
              onClick={() => navigate("/register")}
            >
              Register
            </Button>

            <Button
              type="link"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </Button>
          </div>

          <Button type="primary" htmlType="submit" block>
            Login
          </Button>

        </Form>
      </Card>
    </div>
  );
}